// Het bord in de gang van een studentenhuis of gedeelde woning (golf 6b, 0043_huishoudtypes;
// docs/onderzoek/feedback-26-sep.md §3.7 A). Nuchter en volwassen: geen kindertaal, geen sterren,
// van 2 tot 3 meter te lezen. De kiosk laadt alleen nl in de bundle; andere talen als pakket.
export const hallwayNl = {
    thisWeek: 'Deze week aan de beurt',
    today: 'Vandaag',
    cooks: '{name} kookt',
    nobody: 'Niemand',
    done: 'Gedaan',
    doneBy: 'Gedaan door {name}',
    tapHint: 'Tik op een klus als hij gedaan is',
    whoDid: 'Wie deed {duty}?',
    saved: '{duty}: gedaan door {name}',
    undo: 'Oeps, terugdraaien',
    undone: 'Teruggedraaid',
    agenda: 'Huisagenda',
    nothingPlanned: 'Niets gepland',
    close: 'Sluiten',
    allDone: 'Alles gedaan deze week',
    noDuties: 'Nog geen rooster. Maak het in de app bij Beurtrooster.',
};
//# sourceMappingURL=hallway.nl.js.map